import {forwardRef, useEffect, useRef, useState} from "react";
import {generateUUID2, getImagePathWithThemeSvg, getItem, isDarkMode, isInDraw} from "../../utils";
import WebViewItem from "@/views/Webview/WebviewItem";
import {getWebFavorList, getWebHistoryByUrl, getWebHistoryList, updateWebHistory} from "@model/webHistory";
import global from "@/global";
import {isZh} from "@/language";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";
import {Dropdown, Progress ,Popover} from "antd";
import {
    IconOpenInPopup, IconWebBrowseAddToLibrary,
    IconWebBrowseCopylink, IconWebBrowseOpenFromLibrary,
    IconWebBrowseOpenFullscreen, IconWebBrowseOpenInDefault,
    IconWebBrowseOpenInPopup, IconWebBrowseResetZoom,
    IconWebBrowseSearch, IconWebBrowseSet, IconWebBrowseZoomIn, IconWebBrowseZoomOut
} from "@/Icon";
import { t } from "i18next";
import {DROPDOWN_MIN_WIDTH, KEY_WEBVIEWER_CONFIG, MENU_SEPARATOR, TITLE_BAR_HEIGHT} from "@/Const";
import {handleWebviewMenu} from "@/views/Webview/HandleWebviewMenu";
import webViewItem from "@/views/Webview/WebviewItem";
import {atomSliderWidth} from "@/App";
import {useAtom} from "jotai";
import PlaceHolderImage from "@/views/Webview/PlaceHolderImage";
import {atomCommonSliderContainerWidth} from "@/views/Home/HomeIndex";
import {isMac} from "@/Utility";

const CustomWebView = forwardRef((props:{pointerEvents:any,selectType?:any,url?:any,from?:any},ref)=>{
    const [rightSliderWidth,setRightSliderWidth] = useAtom(atomSliderWidth);
    const [commonSliderContainerWidth, setCommonSliderContainerWidth] = useAtom(atomCommonSliderContainerWidth);
    const [arrayTabUrls,setArrayTabUrls] = useState<any>([]);
    const [inputUrl,setInputUrl] = useState('');
    const [dbWebInfo,setDbWebInfo] = useState<any>(null);
    const [arrayFavorList,setArrayFavorList] = useState([]);
    const [isShowFavorList,setIsShowFavorList] = useState(false);
    const [isShowMore,setIsShowMore] = useState(false);
    const [arraySearchHistory,setArraySearchHistory] = useState<any>([]);
    const [isShowSearchList,setIsShowSearchList] = useState(false);
    const [currentWebInfo,setCurrentWebInfo] = useState<any>(null);//当前加载的....
    const [activeWebview,setActiveWebview] = useState<any>(null);
    const [isSearch,setIsSearch] = useState(false);
    const [searchInfo,setSearchInfo] = useState({currentIndex:0,totalCount:0})
    const [arrayWebviews,setArrayWebviews] = useState<any>([]);//这个只有添加和删除的时候才需要更新....
    const [activitySearchHistoryIndex,setActivitySearchHistroyIndex] = useState<any>(-1);
    const [mapIsImageLoaded,setMapIsImageLoaded] = useState<any>({});

    const arrayWebViewRefs = useRef<any>([]);
    const mMouseDownTimesInInputUrl = useRef(0);
    const divInputContainerRef = useRef(null);
    const inputSearchRef = useRef(null);
    const inputUrlRef = useRef(null);


    const GET_WEBBROWSE_MORE = ()=>{
        const menu = [
            getItem(t("Search"), 'search', <IconWebBrowseSearch/>, undefined, undefined, () => {

            }),
            getItem(t("Copy link"), 'copyLink', <IconWebBrowseCopylink/>, undefined, undefined, () => {

            }),
            // getItem(t("Open in popup"), 'openInPopup', <IconWebBrowseOpenInPopup/>, undefined, undefined, () => {
            //
            // }),
            // getItem(t("Open in fullscreen"), 'openInFullscreen', <IconWebBrowseOpenFullscreen/>, undefined, undefined, () => {
            //
            // }),
            getItem(t("OpenInDefaultBrowser"), 'openInDefaultBrowser', <IconWebBrowseOpenInDefault/>, undefined, undefined, () => {

            }),
            getItem(t("Settings"), 'setting', <IconWebBrowseSet/>, undefined, undefined, () => {

            }),
            getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

            }),
            // getItem(t("Add to library"), 'addToLibrary', <IconWebBrowseAddToLibrary/>, undefined, undefined, () => {
            //
            // }),
            getItem(t("OpenFromLibrary"), 'openFromLibrary', <IconWebBrowseOpenFromLibrary/>, undefined, undefined, () => {

            }),
            getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

            }),
            getItem(t("Zoom in"), 'zoomIn', <IconWebBrowseZoomIn/>, undefined, undefined, () => {

            }),
            getItem(t("Reset zoom"), 'resetZoom', <IconWebBrowseResetZoom/>, undefined, undefined, () => {

            }),
            getItem(t("Zoom out"), 'zoomOut', <IconWebBrowseZoomOut/>, undefined, undefined, () => {

            }),
        ]
        return menu;
    }

    const GET_ARRAY_FAVORITEM_MORE = ()=>{
        const item = [
            {
                key:'edit',
                label:t('Edit')
            },
            {
                key:'delete',
                label:t('Delete')
            }
        ]
        return item;
    }

    useEffect(() => {
        const webCache = global.g_webCache;
        if (webCache.length == 0){
            const defaultUrl:any = createWebItem(getDefaultUrl());
            webCache.push(defaultUrl);
        }else{
            // if (props.url){
            //     const defaultUrl:any = createWebItem(props.url);
            //     webCache.push(defaultUrl);
            // }
        }
        arrayWebViewRefs.current = [];
        setArrayTabUrls(webCache);

        //webviews只需要一个标题和即可.
        setArrayWebviews(webCache);

        //刷新收藏
        refreshFavor();
    }, []);

    useEffect(() => {
        // arrayWebViewRefs.current = [];
        global.g_webCache = [...arrayTabUrls];
        //配置当前激活的url
        const nIndex  = arrayTabUrls.findIndex(p=>p.isActive);
        if (nIndex != -1){
            const  item = arrayTabUrls[nIndex];
            if (document.activeElement?.id != 'input-web-url'){
                setInputUrl(item.url);
            }
            refreshWebHistoryFavor(item.url);
            //更新arrayWebviews中的
            const webItem = arrayWebviews.find(p=>p.id == item.id);
            if (webItem){
                webItem.favicon = item.favicon;
                webItem.title = item.title;
                webItem.url = item.url;
            }
            setCurrentWebInfo(item);
            setActiveWebview(arrayWebViewRefs.current[nIndex]);
        }

    }, [arrayTabUrls]);

    useEffect(() => {
        if (props.url){
            setTimeout(()=>{
                //new 一个
                const arrayNews = [...global.g_webCache];
                arrayNews.forEach(p=>{
                    p.isActive = false;
                })
                const newUrl = createWebItem(props.url);
                arrayNews.push(newUrl);
                setArrayTabUrls(arrayNews);

                setArrayWebviews(arrayNews);
            },300)

        }
    }, [props.url]);


    useEffect(() => {
        document.body.addEventListener('keydown',onKeydown);

        return ()=>{
            document.body.removeEventListener('keydown',onKeydown);
        }
    });

    function onKeydown(event){
        if (event.key == KEYS.ENTER){
            if (isSearch){
                findNext();
            }else{
                if (isShowSearchList){
                    //取选中的这个转到...
                    if (activitySearchHistoryIndex >= -1){
                        let szUrl = '';
                        if (activitySearchHistoryIndex == -1){
                            //搜索
                            szUrl = getDefaultSearchUrl(inputUrl);
                        }else{
                            const item = arraySearchHistory[activitySearchHistoryIndex];
                            szUrl = item.url;
                        }
                        toNavgiate(szUrl);
                        setInputUrl(szUrl);
                    }
                }
            }
        }else if (event.key == KEYS.ARROW_DOWN){
            let nIndex = activitySearchHistoryIndex;
            nIndex++;
            if (nIndex >= arraySearchHistory.length){
                nIndex = -1;
            }
            setActivitySearchHistroyIndex(nIndex)
        }else if (event.key == KEYS.ARROW_UP){
            let nIndex = activitySearchHistoryIndex;
            nIndex--;
            if (nIndex < -1){
                nIndex = arraySearchHistory.length -1;
            }
            setActivitySearchHistroyIndex(nIndex)
        }
    }

    /**
     * 默认url
     */
    const getDefaultUrl = ()=>{
        let szUrl = isZh()?'https://cn.bing.com/?mkt=zh-CN':'https://www.google.com/';
        const szWebviewConfig = localStorage.getItem(KEY_WEBVIEWER_CONFIG);
        if (szWebviewConfig){
            const jConfig = JSON.parse(szWebviewConfig);
            if (jConfig.defaultUrl) {
                if (!jConfig.defaultUrl.startsWith('http')) {
                    szUrl = 'https://'+ jConfig.defaultUrl;
                }else {
                    szUrl = jConfig.defaultUrl;
                }
            }
        }
        return szUrl;
    }

    const getDefaultSearchUrl = (szSearchKey:any)=>{
        let szUrl = '';
        if (isZh()){
            szUrl = `https://cn.bing.com/search?q=${szSearchKey}`
        }else{
            szUrl = `https://www.google.com/search?q=${szSearchKey}`;
        }
        const szWebviewConfig = localStorage.getItem(KEY_WEBVIEWER_CONFIG);
        if (szWebviewConfig){
            const jConfig = JSON.parse(szWebviewConfig);
            if (jConfig.defaultSearch) {
                if ('google' == jConfig.defaultSearch) {
                    szUrl = `https://www.google.com/search?q=${szSearchKey}`;
                }else if ('bing' == jConfig.defaultSearch){
                    szUrl = `https://cn.bing.com/search?q=${szSearchKey}`
                }else if ('baidu' == jConfig.defaultSearch){
                    szUrl = `https://www.baidu.com/s?wd=${szSearchKey}`
                }
            }
        }

        return szUrl;
    }

    /**
     * 刷新收藏列表
     */
    const refreshFavor = ()=>{
        getWebFavorList().then(res=>{
            res.sort((a,b)=>{
                return b.favirateTime - a.favirateTime;
            })
            setArrayFavorList(res);
        })
    }

    /**
     * 从数据库刷新这个url是否被收藏
     * @param szUrl
     */
    const refreshWebHistoryFavor = (szUrl)=>{
        if (!szUrl) {
            setDbWebInfo(null);
            return;
        }
        getWebHistoryByUrl(szUrl).then(res=>{
            setDbWebInfo(res);
        })
    }

    const createWebItem = (szUrl)=>{
        return {
            id:generateUUID2(),
            url:szUrl,
            isActive:true,
            isLoading: true,
            canGoBack: false,
            canGoForward: false,
            favicon:'',
            createTime:Date.now(),
            updateTime:Date.now()
        }
    }

    /**
     * 当前激活的
     */
    const getActiveItem = ()=>{
        const item = arrayTabUrls.find(p=>p.isActive);
        return item;
    }

    /**
     * 转到
     * @param szNewUrl
     */
    const toNavgiate = (szNewUrl:any,isSaveToHistory = true)=>{
        const arrayNewTabs = [...arrayTabUrls];
        const activeItem = arrayNewTabs.find(p=>p.isActive);
        activeItem.title = szNewUrl;
        activeItem.url = szNewUrl;
        activeItem.favicon = '';
        setArrayTabUrls(arrayNewTabs);
        setArrayWebviews(arrayNewTabs);

        setIsShowSearchList(false);
        hiddenFind();

        refreshWebHistoryFavor(szNewUrl);

        if (isSaveToHistory){
            getWebHistoryByUrl(szNewUrl).then(res=>{
                if (res){
                    res.updateTime = Date.now();
                }else{
                    res = createWebItem(szNewUrl);
                }
                //更新...
                updateWebHistory(res);
            })
        }
    }
    /**
     * 当前激活的webviewitem
     */
    const getActiveWebItemRef = ()=>{
        const nIndex = arrayTabUrls.findIndex(p=>p.isActive);
        return arrayWebViewRefs.current[nIndex];
    }


    /**
     * 处理书签事件...
     * @param e
     */
    const handleFavorMore = (e,p)=>{
        e.domEvent.stopPropagation();
        if (e.key == 'edit'){
            window.showDialogWebBrowseAddBookmark((p),()=>{
                const arrayNew = [...arrayTabUrls];
                setArrayTabUrls(arrayNew);
                refreshFavor();
            })
        }else if (e.key == 'delete'){
            window.showMessageBox(t("Tips"),t("DeleteWebBookmark"),t("Cancel"),t("Delete"),null,()=>{
                p.isFavor = 0;
                updateWebHistory(p).then(res=>{
                    const arrayNew = [...arrayTabUrls];
                    setArrayTabUrls(arrayNew);
                    refreshFavor();
                })
            })
        }
    }

    const handleWebMoreClick = (e)=>{
        handleWebviewMenu(e.key,currentWebInfo,getActiveWebItemRef(),(data)=>{
            if (data.action == 'open'){
                toNavgiate(data.data.fileName);
            }else if (data.action == 'search'){
                setIsSearch(true);
                setTimeout(()=>{
                    inputSearchRef.current?.focus();
                },200)
            }
        });
    }

    /**
     * 关闭搜索
     */
    const hiddenFind = ()=>{
        if (isSearch){
            setIsSearch(false);
            setSearchInfo({currentIndex:0,totalCount:0});
            const webItem = getActiveWebItemRef();
            webItem.stopFindInPage();
        }
    }

    /**
     * 查找下一个
     */
    const findNext = ()=>{
        const szValue = inputSearchRef.current?.value.trim();
        const webItem = getActiveWebItemRef();

        const options = {
            forward: true,
            findNext: true,
            matchCase: false
        };
        webItem.findText(szValue,options)
    }


    /**
     * 搜索历史记录
     */
    const renderSearchHistory = ()=>{
        return <div className={'flex-col default-font-size'} style={{width:`${divInputContainerRef.current?.offsetWidth}px`,overflow:'hidden'}}>
            {
                inputUrl &&
                <div className={'flex-row-vertical-center cursor-pointer'}
                     style={{minHeight: '32px', padding: '0px 12px',background:activitySearchHistoryIndex == -1?'var(--hoverd-background-777)':''}} onClick={(e) => {
                    //搜索
                    const szSearchUrl = getDefaultSearchUrl(inputUrl);
                    toNavgiate(szSearchUrl, false);
                }}>
                    <img className={'img-16'} src={getImagePathWithThemeSvg('webbrowse_search_history')}/>
                    <span className={'ml-8 span-single-line'}>{t('Search for') + ` "${inputUrl}"`}</span>
                </div>
            }

            {
                arraySearchHistory.length > 0 &&
                <>
                    {
                        inputUrl &&
                        <div className={'mt-4'} style={{borderBottom: '1px solid var(--border-color)'}}></div>
                    }

                    <div className={'flex-col mt-4'} style={{marginTop:inputUrl?'4px':'2px'}}>
                    {
                            arraySearchHistory.map((p,index) => {
                                return <div className={'flex-row-vertical-center cursor-pointer'}
                                            onClick={(e) => {
                                                toNavgiate(p.url,true);
                                }}
                                            style={{minHeight: '32px', padding: '0 12px',background:index == activitySearchHistoryIndex?'var(--hoverd-background-777)':''}}
                                            onMouseMove={(e)=>{
                                                setActivitySearchHistroyIndex(index);
                                }}>
                                    <img className={'img-16'} src={getImagePathWithThemeSvg('webbrowse_history')}/>
                                    <span className={'ml-8 span-single-line'}>{p.url}</span>
                                </div>
                            })
                        }
                    </div>
                </>
            }

        </div>
    }

    /**
     * 收藏列表
     */
    const renderFavorList = () => {
        return <div className={'flex-col default-font-size'} style={{gap: '0px 0',maxWidth:'520px'}}>
            {
                arrayFavorList.length > 0?
                arrayFavorList.map(p => {
                    return <div className={'flex-row-vertical-center hovered-777-radius-0'}
                                style={{minHeight: '32px', padding: '0 12px'}} onClick={(e) => {
                        setIsShowFavorList(false);
                        //转到...
                        toNavgiate(p.url);
                    }}>
                        <PlaceHolderImage url={p.favicon}/>
                        <span className={'ml-8 mr-12 span-single-line'}>{p.title}</span>
                        <Dropdown arrow={false} trigger={['click']} menu={{
                            items: GET_ARRAY_FAVORITEM_MORE(),onClick:(e)=>{
                                handleFavorMore(e,p);
                            }}} overlayStyle={{minWidth:`${DROPDOWN_MIN_WIDTH}px`}}>
                            <img className={'img-16 cursor-pointer'} style={{marginLeft:'auto'}} src={getImagePathWithThemeSvg('webbrowse_favoritem_more')} onClick={(e)=>{
                                e.stopPropagation();

                            }}/>
                        </Dropdown>
                    </div>
                }):<div style={{color:'var(--color-9A9A9A)',padding:'4px 16px'}}>{t("AddBookmarksToQuickly")}</div>
            }
        </div>
    }

    const renderWebviewItem = ()=>{
        // for (let i=0;i<arrayWebViewRefs.current.length;i++){
        //     arrayWebViewRefs.current[i].onRemove();
        // }
        // arrayWebViewRefs.current = [];
        if (isInDraw()){
            if (props.selectType != 'webview'){
                return <></>
            }
        }

        return (rightSliderWidth > 0 || commonSliderContainerWidth >0) ?
            arrayWebviews.map((p, index) => {
                return <div key={p.id} style={{width:'100%',height:isMac()?'calc(100% - 34px)':`calc(100% - 34px)`,display:p.isActive?'inherit':'none',position:'absolute',left:'0',top:isSearch?'56px':'34px'}}>
                    <div style={{width:'100%',height:'100%'}}>
                        <WebViewItem  item={p} ref={(ref)=>{
                            if (ref) {
                                // arrayWebViewRefs.current[index]?.onRemove();
                                arrayWebViewRefs.current[index] = ref;
                            }
                        }} onClose={() => {

                        }} onPageInfoUpdate={(data)=>{
                            const newTabs = [...arrayTabUrls];
                            newTabs.splice(index,1,data);
                            setArrayTabUrls(newTabs);

                            console.log(data.url);
                        }} onProgressLoading={(progress)=>{

                        }} onUpdateSearchInfo={(activeMatchOrdinal,matchesCount)=>{
                            const newSearchInfo = {...searchInfo};
                            newSearchInfo.currentIndex = activeMatchOrdinal;
                            newSearchInfo.totalCount = matchesCount;
                            setSearchInfo(newSearchInfo);
                        }} onMouseDown={(e)=>{
                            if (isShowSearchList){
                                setIsShowSearchList(false);
                            }
                            if (isShowFavorList){
                                setIsShowFavorList(false);
                            }
                            if (isShowMore){
                                setIsShowMore(false);
                            }

                        }}/>
                    </div>
                </div>
            }):<></>
    }

    const getHeight = ()=>{
        if (props.from == 'drawIndex'){
            return isMac()?'calc(100% - 34px)':'calc(100% - 72px)';
        }
        return '100%';
    }

    return<div id={'div-custom-webview-container'} className={'flex-col'} style={{height:getHeight(),pointerEvents:props.pointerEvents}}>
        <div className={'flex-row-vertical-center'} style={{gap: '0px 16px',padding:'16px 16px'}}>
            <img className={'img-14 cursor-pointer'} src={getImagePathWithThemeSvg('web_new')} onClick={(e) => {
                const arrayNews = [...arrayTabUrls];
                hiddenFind();//关闭搜索

                arrayNews.forEach(p=>{
                    p.isActive = false;
                })

                const newUrl = createWebItem(getDefaultUrl());
                arrayNews.push(newUrl);
                setArrayTabUrls(arrayNews);

                setArrayWebviews(arrayNews);
            }}/>
            <img className={'img-14 cursor-pointer'} src={getImagePathWithThemeSvg(activeWebview?.canGoBack()?'web_back':'web_back_disabled')} onClick={(e) => {
                const webviewRef = getActiveWebItemRef();
                webviewRef.handleGoBack();
            }}/>
            <img className={'img-14 cursor-pointer'} src={getImagePathWithThemeSvg(activeWebview?.canGoForward()?'web_forward':'web_forward_disabled')} onClick={(e) => {
                const webviewRef = getActiveWebItemRef();
                webviewRef.handleGoForward();
            }}/>
            <img className={'img-14 cursor-pointer'} src={getImagePathWithThemeSvg('web_refresh')} onClick={(e) => {
                const webviewRef = getActiveWebItemRef();
                webviewRef.handleReload();
            }}/>
            <Popover arrow={false} destroyTooltipOnHide={true} open={isShowSearchList} onOpenChange={(e)=> {
                // setIsShowSearchList(e)
            }}
                     trigger={['click']}
                     content={renderSearchHistory()} placement={'bottomLeft'} overlayInnerStyle={{margin: '0', padding: '6px 0'}}>
                <div ref={divInputContainerRef} className={'flex-row-vertical-center'} style={{
                    flexGrow: '1',
                    background: 'var(--webview-url-input-backgroun-color)',
                    padding: '0 8px',
                    borderRadius: '4px'
                }} onClick={(e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                }}>
                    <input ref={inputUrlRef} id={'input-web-url'} className={'input-solid span-single-line'} value={decodeURI(inputUrl) || ''}
                           style={{height: '28px', flexGrow: '1',marginRight:'10px',overflow:'hidden'}} onKeyDown={(e) => {
                        if (e.key == KEYS.ENTER) {
                            if (activitySearchHistoryIndex >= -1){
                                return;//使用搜索的...
                            }
                            let szUrl = e.currentTarget.value.trim();
                            setTimeout(()=>{
                                if (szUrl.startsWith('www.')) {
                                    szUrl = 'https://'+szUrl;
                                }else if (szUrl.startsWith('https')){

                                }else if (szUrl.includes('.')){
                                    const arraySplits = szUrl.split('.');
                                    const szLast = arraySplits[arraySplits.length-1];
                                    if (szLast.length < 10){
                                        if (!szUrl.startsWith('http')){
                                            szUrl = 'https://'+szUrl;
                                        }
                                    }
                                }
                                else {
                                    szUrl = getDefaultSearchUrl(szUrl);
                                }
                                setInputUrl(szUrl);
                                toNavgiate(szUrl);
                            },100)
                        }
                    }}
                   onInput={(e) => {
                       setActivitySearchHistroyIndex(-2);
                            let szValue = e.currentTarget.value;
                            setInputUrl(szValue);
                            if (szValue){
                                setIsShowSearchList(true);
                            }
                            getWebHistoryList(szValue).then(res=>{
                                setArraySearchHistory(res);
                            })
                    }} onMouseDown={(e) => {
                        e.stopPropagation();
                        const input = e.currentTarget;
                        if (mMouseDownTimesInInputUrl.current == 0) {
                            setTimeout(() => {
                                let nSel = input.value.length//input.selectionEnd;
                                input.setSelectionRange(0, nSel);
                            }, 100)
                        }
                        mMouseDownTimesInInputUrl.current++;
                    }} onBlur={(e) => {
                        mMouseDownTimesInInputUrl.current = 0;
                        e.currentTarget.scrollTo(0,0);
                        setTimeout(()=>{
                            setIsShowSearchList(false);
                        },200)
                    }}/>
                    <img className={'img-14 cursor-pointer'} style={{marginLeft: 'auto', flexShrink: '0'}}
                         src={getImagePathWithThemeSvg(dbWebInfo?.isFavor == 1 ? 'web_add_favor_blue' : 'web_add_favor')}
                         onClick={(e) => {
                             e.stopPropagation();
                             //添加到书签..
                             const item = getActiveItem();
                             if (dbWebInfo){
                                 if (!dbWebInfo.title) {
                                     dbWebInfo.title = item.title;
                                 }
                                 if (!dbWebInfo.favicon){
                                     dbWebInfo.favicon = item.favicon;
                                 }
                             }
                             window.showDialogWebBrowseAddBookmark((dbWebInfo || item), () => {
                                 const arrayNew = [...arrayTabUrls];
                                 setArrayTabUrls(arrayNew);
                                 refreshFavor();
                             })
                         }}/>
                </div>
            </Popover>

            <Popover arrow={false} destroyTooltipOnHide={true} open={isShowFavorList} onOpenChange={(e) => setIsShowFavorList(e)}
                     trigger={['click']} placement={'bottomLeft'}
                     overlayStyle={{minWidth: '300px',}}
                     overlayInnerStyle={{margin: '0', padding: '6px 0'}} content={renderFavorList()}>
                <img className={'img-14 cursor-pointer'} src={getImagePathWithThemeSvg('web_favor')} onClick={(e) => {

                }}/>
            </Popover>


            <Dropdown trigger={['click']} open={isShowMore} onOpenChange={(e)=>setIsShowMore(e)} menu={{items: GET_WEBBROWSE_MORE(),onClick:handleWebMoreClick}}
                      overlayStyle={{minWidth: `${DROPDOWN_MIN_WIDTH}px`}}>
                <img className={'img-14 cursor-pointer'} src={getImagePathWithThemeSvg('web_more')} onClick={(e) => {

                }}/>
            </Dropdown>

        </div>

        {/*web标签页*/}
        <div className={'flex-col'} style={{height: '100%', width: '100%',position:'relative'}}>
            <div className={'flex-row-vertical-center'}
                 style={{border: '1px solid var(--border-color)', position: 'relative',height:isSearch?'49px':''}}>
                {
                    arrayTabUrls.map((p, index) => {
                        return <div className={'flex-row-vertical-center cursor-pointer'}
                                    style={{
                                        maxWidth: '180px',
                                        minWidth: '100px',
                                        height: '32px',
                                        background: p.isActive ? 'var(--webview-tab-background-color)' : 'transparent',
                                        padding: '0 10px',
                                        borderRight: '1px solid var(--border-color)'
                                    }}
                                    onClick={(e) => {
                                        const arrayNew = [...arrayTabUrls];

                                        arrayNew.forEach(pp => {
                                            pp.isActive = false;

                                        })

                                        p.isActive = true;
                                        setInputUrl(p.url);
                                        setArrayTabUrls(arrayNew);
                                        setArrayWebviews(arrayNew);
                                    }}>
                            <img className={'img-14'} src={p.favicon || getImagePathWithThemeSvg('default_web_icon')}/>
                            <span className={'ml-4 span-single-line'}>{p.title}</span>
                            <div style={{width:'6px'}}></div>
                            <img style={{marginLeft: 'auto'}} className={'img-14 ml-16 cursor-pointer'}
                                 src={getImagePathWithThemeSvg('web_tab_close')} onClick={(e)=>{
                                     e.stopPropagation();
                                if (arrayTabUrls.length == 1){
                                    //转到默认的主页...
                                    arrayTabUrls[0].isActive = true;
                                    toNavgiate(getDefaultUrl());
                                    return;
                                }
                                const arrayNew = [...arrayTabUrls];
                                const nIndex = arrayNew.findIndex(pp=>pp.id == p.id);
                                const tabItem = arrayNew[nIndex];
                                arrayNew.splice(nIndex,1);

                                if (tabItem.isActive) {
                                    //转到上一个.
                                    if (nIndex > 0) {
                                        arrayNew[nIndex - 1].isActive = true;
                                    }else {
                                        arrayNew[nIndex].isActive = true;
                                    }
                                }
                                setArrayTabUrls(arrayNew);
                                setArrayWebviews(arrayNew);
                            }}/>
                        </div>
                    })
                }

                {
                    isSearch &&
                    <div className={'flex-row-vertical-center'} style={{gap:'0 12px',position:'absolute',left:'0',top:'0',width:'100%',background:isDarkMode()?'#282828':'#FBFBFB',height:'44px',padding:'0 16px',}}>
                        <input ref={inputSearchRef} className={'input-solid'} style={{flexGrow: '1',borderRadius:'4px',padding:'0 8px'}} onInput={(e)=>{
                            const szValue = e.currentTarget.value.trim();
                            const webItem = getActiveWebItemRef();
                            if (szValue){
                                const options = {
                                    forward: true,
                                    findNext: false,
                                    matchCase: false
                                };
                                webItem.findText(szValue);
                                // setSearchInfo({currentIndex:nTotal>0?1:0,totalCount:nTotal});
                            }else {
                                setSearchInfo({currentIndex:0,totalCount:0});
                                webItem.stopFindInPage();
                            }
                        }}/>
                        <span>{(searchInfo.currentIndex)+'/'+searchInfo.totalCount}</span>
                        <img className={'img-16 cursor-pointer'} src={getImagePathWithThemeSvg('web_search_prev')} onClick={(e)=>{
                            // const newSearchInfo = {...searchInfo};
                            // if (newSearchInfo.currentIndex  > 0){
                            //     newSearchInfo.currentIndex --;
                            // }
                            // setSearchInfo(newSearchInfo);

                            const szValue = inputSearchRef.current?.value.trim();
                            const webItem = getActiveWebItemRef();

                            const options = {
                                forward: false,
                                findNext: true,
                                matchCase: false
                            };
                            webItem.findText(szValue,options)
                        }}/>
                        <img className={'img-16 cursor-pointer'} src={getImagePathWithThemeSvg('web_search_next')} onClick={(e)=>{
                            findNext();
                        }}/>
                        <img className={'img-16 cursor-pointer'} src={getImagePathWithThemeSvg('web_search_close')} onClick={(e)=>{
                            hiddenFind();
                        }}/>
                    </div>
                }

            </div>
            {
                renderWebviewItem()
            }
        </div>
    </div>
})

export default CustomWebView;

























